import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[confirmationAlert]'
})
export class ConfirmationAlertDirective {
  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    let text;
    
      if (confirm("Directive Test.") == true) {
        text = "You pressed OK!";
      } else {
        text = "You canceled!";
      }
    alert(text);
  }

}
